import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {baseUrl} from "../../../../core/constants/base-url";
import {productCardsDefectValuesResourceType} from "../configs/product-card-defects-config";
import {
  CreateProductCardsDefectValueParams,
  ProductCardDefectValue,
  UpdateProductCardsDefectValueParams
} from "../types/product-card-defect.types";
import {Observable} from "rxjs";
import {RecordsDataRequestQueryParams} from "../../../../core/types/records-table.types";
import {jsonPathHeaders} from "../../../../core/models/http-headers";


@Injectable({
  providedIn: 'root'
})
export class ProductCardsDefectValuesApiService {
  private http: HttpClient = inject(HttpClient);
  private url: string = `${baseUrl}/${productCardsDefectValuesResourceType.path}`;

  public getProductCardsDefectValuesPages(): Observable<Array<ProductCardDefectValue>> {
    return this.http.get<Array<ProductCardDefectValue>>(`${this.url}/p`);
  }

  public getProductCardsDefectValues(queryParams: RecordsDataRequestQueryParams): Observable<Array<ProductCardDefectValue>> {
    return this.http.get<Array<ProductCardDefectValue>>(`${this.url}/`, {
      params: queryParams
    });
  }

  public getProductCardDefectValue(id: number): Observable<ProductCardDefectValue> {
    return this.http.get<ProductCardDefectValue>(`${this.url}/${id}`);
  }

  public createProductCardsDefectValue({ value, productDefectId, productCardId }: CreateProductCardsDefectValueParams): Observable<ProductCardDefectValue> {
    return this.http.post<ProductCardDefectValue>(`${this.url}`, { value }, { params: { productDefectId: productDefectId, productCardId: productCardId } });
  }

  public updateProductCardsDefectValue({ id, value }: UpdateProductCardsDefectValueParams): Observable<ProductCardDefectValue> {
    const patchOperations = [{
      'op': 'add',
      'path': `/value`,
      'value': value !== undefined ? value : null
    }];

    return this.http.patch<ProductCardDefectValue>(`${this.url}/${id}`, patchOperations, {
      headers: jsonPathHeaders
    });
  }

  public deleteProductCardsDefectValue(id: number): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }
}
